
import Form from "./Form.vue";
import UsuariosData from "./UsuariosData";
import { mapGetters } from "vuex";

export default {
  name: "app-usuario-create",
  data() {
    return {
      usuario: new UsuariosData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
